import React, { useMemo } from "react";
import { faUserCircle } from "@fortawesome/pro-solid-svg-icons";
import { Image, JerseyModeEnum } from "../../../client/api";
import ClavaImage from "../ClavaImage";
import Jersey from "../Jersey";
import IconWithBackground from "../IconWithBackground";

interface PlayerImageProps {
  image?: Image | null;
  width: number;
  className?: string;
  alt?: string;
  rounded?: boolean;
  round?: boolean;
  jerseyColor1?: string;
  jerseyColor2?: string;
  jerseyMode?: JerseyModeEnum;
}

const PlayerImage: React.FC<PlayerImageProps> = ({
                                                   image,
                                                   width,
                                                   className,
                                                   alt,
                                                   rounded,
                                                   round,
                                                   jerseyColor1,
                                                   jerseyColor2,
                                                   jerseyMode
                                                 }) => {
  const chosen = useMemo(() => image ?? null, [image]);

  if (!chosen) {
    if (jerseyColor1 && jerseyMode && jerseyColor1.trim() !== "") {
      const color1 = jerseyColor1.trim();
      const color2 = jerseyColor2 && jerseyColor2.trim() !== "" ? jerseyColor2.trim() : color1;

      return (
        <div style={{ width, aspectRatio: 1 }}>
          <Jersey
            color1={color1}
            color2={color2}
            mode={jerseyMode}
            size={width}
            className="w-full h-full"
          />
        </div>
      );
    }

    return (
      <div className={`${className ?? ""}`} style={{ width, aspectRatio: 1 }}>
        <IconWithBackground
          icon={faUserCircle}
          className="w-full h-full text-font-600 dark:text-font-600-dark"
        />
      </div>
    );
  }

  return (
    <ClavaImage
      image={chosen}
      width={width}
      className={className}
      alt={alt}
      forceAspectRatio={round || className?.includes("rounded-full") ? 1 : undefined}
      rounded={rounded}
      round={round}
      format={width < 128 ? "thumb" : width < 512 ? "icon" : "full"}
    />
  );
};

export default PlayerImage;




